import React from "react";
import { convertStructToJson } from "./../../../../../ricos-content/lib/struct-converters.js";
import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import {
  getAlignmentClassName,
  getSizeClassName,
  getTextWrapClassName
} from "./get-class-names.js";
import { nodeViewContainer as NodeViewContainer } from "./node-view-container.js";
const isDraftEntityConfig = (data) => (data.width || data.alignment || data.textWrap) && (["content", "original", "fullWidth", "small"].includes(data.size) || ["center", "left", "right"].includes(data.alignment));
const toContainerData = (data) => ({
  ...typeof data.size === "string" ? { width: { size: data.size.toUpperCase() } } : {},
  ...typeof data.alignment === "string" ? { alignment: data.alignment.toUpperCase() } : {},
  ...typeof data.textWrap !== "undefined" ? { textWrap: data.textWrap !== "nowrap" } : {}
});
const getContainerData = (externalData) => {
  if (isDraftEntityConfig(externalData.config || {})) {
    return toContainerData(externalData.config);
  }
  return externalData.containerData;
};
const Plugin = ({
  type,
  context,
  node,
  nodeIndex,
  children,
  pluginComponent: { component: Component }
}) => {
  const settings = context.config?.[type] || {};
  const componentData = node.externalData && convertStructToJson(node.externalData) || {};
  const containerData = getContainerData(componentData) || {};
  const componentProps = {
    type,
    componentData,
    settings,
    children,
    ...context,
    blockKey: node.id
  };
  const customClassNames = {
    alignment: getAlignmentClassName(containerData),
    size: getSizeClassName(containerData),
    textWrap: getTextWrapClassName(containerData)
  };
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex, customClassNames }, /* @__PURE__ */ React.createElement(Component, { ...componentProps }));
};
const fromExternalNode = (args) => {
  return {
    [Node_Type.EXTERNAL]: ({ node, nodeIndex }) => {
      return /* @__PURE__ */ React.createElement(Plugin, { key: node.id, node, nodeIndex, ...args });
    }
  };
};
export {
  fromExternalNode
};
//# sourceMappingURL=from-external-node.js.map
